import { Injectable } from '@angular/core';
import { ErrorHandlerService } from '@y42/error-handling';
import { AbstractFeatureGitService, getY42GitPath, Y42GitFolders } from '@y42/feature/git';
import { Y42MetadataGitModel } from '@y42/feature/json-schema';
import { GitQuery, GitService } from '@y42/git';
import { OrchestrationSettingsGitModel, OrchestrationStoreModel } from './orchestration.model';

@Injectable({ providedIn: 'root' })
export class OrchestrationGitService extends AbstractFeatureGitService<
  OrchestrationStoreModel,
  Y42GitFolders.Orchestration
> {
  constructor(
    protected readonly git: GitService,
    protected readonly gitQuery: GitQuery,
    protected readonly errorHandlerService: ErrorHandlerService,
  ) {
    super({
      gitQuery,
      git,
      name: 'Orchestration-Git',
      basePath: getY42GitPath(Y42GitFolders.Orchestration),
      errorHandlerService,
      hydrationDefinition: {
        1: {
          modelType: 'folder',
          models: {
            config: {
              fileName: 'settings.json',
              property: 'config',
            },
            type: {
              fileName: 'settings.json',
              property: 'type',
            },
            enabled: {
              fileName: 'settings.json',
              property: 'enabled',
            },
            forceSchedule: {
              fileName: 'settings.json',
              property: 'forceSchedule',
            },
            cronExpression: {
              fileName: 'settings.json',
              property: 'cronExpression',
            },
            executionTimeout: {
              fileName: 'settings.json',
              property: 'executionTimeout',
            },
            retryConfig: {
              fileName: 'settings.json',
              property: 'retryConfig',
            },
          },
        },
      },
      models: {
        metadata: {
          fileName: 'metadata.json',
          model: Y42MetadataGitModel,
        },
        settings: {
          fileName: 'settings.json',
          model: OrchestrationSettingsGitModel,
        },
      },
    });
  }

  async create(orchestration: OrchestrationStoreModel): Promise<void> {
    const id = orchestration.$name;
    await this.git.createFolder(this.getPath(id), { skipSync: true });
    await this.git.writeFiles([
      {
        path: this.getPath(id, this.cfg.models!.metadata.fileName),
        content: new Y42MetadataGitModel(orchestration),
      },
      {
        path: this.getPath(id, this.cfg.models!.settings!.fileName),
        content: new OrchestrationSettingsGitModel(orchestration),
      },
    ]);
  }
}
